module.exports = __webpack_public_path__ + "img/logo.28e4c2be.png";